import zIndex from "@material-ui/core/styles/zIndex";
import React from "react";
import "../App.css";
import logo from "../assets/img/logo.png";
import slogan from "../assets/img/slogan.png";

export default class Loader extends React.Component {

  render() {
    return (
      <div
        style={{
          backgroundColor: "white",
          height: "100vh",
          width:'100vw',
          display: "flex",
          justifyContent: "center",
          alignItems: "center",
          color:'blue',
          position:'fixed',
          flexDirection:'column',
          zIndex:9
        }}
      >
          <img src={logo} width='150px' />
        <div class="loader">Loading...</div>
      </div>
    );
  }
}
